import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts, QueryParams } from "@ofqual/portal-core/core/types";

// returns both event type and sub type TODO TODO TODO
export class EventTypeService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/eventnotificationeventtypes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data
      .sort((a,b) => a.eventTypeSortOrder - b.eventTypeSortOrder)
      .reduce((acc: Model[], curr: Model) => {
        const existing = acc.find(x => x.eventTypeCode === curr.eventTypeCode);
        // Only add if event current doesn't exist and is active
        if (!existing && curr.active) {
          return [ 
            ...acc,
            { 
              id: Number.parseInt(curr.eventTypeCode), 
              label: curr.eventTypeName,
              eventTypeCode: curr.eventTypeCode,
              active: curr.active
            } 
          ];
        }
        return acc;
      }, []);
  }
}

export class EventSubTypeService extends BaseRemoteService {
  public async getAll(params?: QueryParams): Promise<Model[]> {
    const url = `${this.apiRoot}/eventnotificationeventtypes`;
    const data = await super.getRequest<Model[]>(url);
    if (!!params && params?.parentId != null) {
      return data
        .filter(x => Number.parseInt(x.eventTypeCode) === params.parentId)
        .sort((a,b) => a.eventSubTypeSortOrder - b.eventSubTypeSortOrder)
        .map(x => ({ id: x.id, label: x.eventSubTypeName, parentId: Number.parseInt(x.eventTypeCode), active: x.active }));
    }

    return data
        .sort((a,b) => {
          const firstSort = (a.eventTypeSortOrder > b.eventTypeSortOrder ? 1 : 0) - (a.eventTypeSortOrder < b.eventTypeSortOrder ? 1 : 0);
          const secondSort = (a.eventSubTypeSortOrder > b.eventSubTypeSortOrder ? 1 : 0) - (a.eventSubTypeSortOrder < b.eventSubTypeSortOrder ? 1 : 0);
          return firstSort || secondSort
        })
        .map(x => ({ id: x.id, label: x.eventSubTypeName, parentId: Number.parseInt(x.eventTypeCode), active: x.active }));
  }
}